/* eslint-disable @typescript-eslint/member-ordering */
// location.service.ts
import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private locationStatus = new BehaviorSubject<boolean>(false);
  locationStatus$ = this.locationStatus.asObservable();

  constructor(private geolocation: Geolocation) {}


  checkLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.locationStatus.next(true);
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            this.locationStatus.next(false);
          }
        }
      );
    } else {
      // If geolocation is not supported, location is off
      this.locationStatus.next(false);
    }
  }
}

